export default __webpack_public_path__ + "static/media/alertIconRed.6ecf5dad.svg";